import React from 'react'

const Loading = () => (
    <div className="loader">Loading...</div>
)

export default Loading